import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const CirculationDeskPage = lazyNamed(() => import('./pages'), 'CirculationDeskPage');
const HoldsQueuePage = lazyNamed(() => import('./pages'), 'HoldsQueuePage');
const HoldsPullListPage = lazyNamed(() => import('./pages'), 'HoldsPullListPage');
const TransfersPage = lazyNamed(() => import('./pages'), 'TransfersPage');
const OverduesPage = lazyNamed(() => import('./pages'), 'OverduesPage');
const OfflineCirculationPage = lazyNamed(() => import('./pages'), 'OfflineCirculationPage');
const ArticleRequestsPage = lazyNamed(() => import('./pages'), 'ArticleRequestsPage');

/**
 * Staff routes for features/circulation. Paths are relative to /staff. Replace a placeholder by building the page in this folder
 * and pointing the lazy import at it; keep the permission wrapper.
 */
export const circulationRoutes: RouteObject[] = [
  { path: 'circulation', element: <RequirePermission permission={['circulate']}><CirculationDeskPage /></RequirePermission> },
  { path: 'circulation/holds', element: <RequirePermission permission={['circulate', 'reserveforothers']}><HoldsQueuePage /></RequirePermission> },
  { path: 'circulation/holds/pull-list', element: <RequirePermission permission={['circulate']}><HoldsPullListPage /></RequirePermission> },
  { path: 'circulation/transfers', element: <RequirePermission permission={['circulate']}><TransfersPage /></RequirePermission> },
  { path: 'circulation/overdues', element: <RequirePermission permission={['circulate']}><OverduesPage /></RequirePermission> },
  { path: 'circulation/offline', element: <RequirePermission permission={['circulate']}><OfflineCirculationPage /></RequirePermission> },
  { path: 'circulation/article-requests', element: <RequirePermission permission={['circulate']}><ArticleRequestsPage /></RequirePermission> },
];
